module.exports = __webpack_public_path__ + "img/T4-D-rc_28.8af001e6.png";